import React, { useEffect, useMemo, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, TextField, Typography, Paper, IconButton, } from "@mui/material";
import HeaderSession from "../../utils/headerSession";
import Loading from "../../load/tabelaLoading";
import api from "../../services/api";
import ListaVazia from "../../utils/listaVazia";
import DownloadIcon from "@mui/icons-material/Download"
import Paginacao from "../../utils/paginacao";
import { useSearchParams } from "react-router-dom";

interface Medicamento {
  _id: string;
  status: string;
  nome: string;
  dciDosagem: string;
  apresentacao: boolean;
  areaTerapeutica: string;
  fabricante: string;
  titularAIM: string;
  numeroRegisto: string;
  dataRegisto: string;
  docs: {
    rcm: string;
    folhetoInformativo: string;
  }
};

interface ConfigLista {
  nextPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  totalItems: number;
}


const MedicamentosRegistados: React.FC = () => {
  const [medicamentos, setMedicamentos] = useState<Medicamento[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  // const [status, setStatus] = useState("Aprovado"); 
  const [searchParams] = useSearchParams();
  // const [page, setPage] = useState(searchParams.get("page"));
  const [page, setPage] = useState<number>(Number(searchParams.get("page")) || 1);
  const [configLista, setConfigLista] = useState<ConfigLista>({
    nextPage: 0,
    hasPreviousPage: false,
    hasNextPage: false,
    totalItems: 0
  });

  useEffect(() => {
    setIsLoading(true);
    // &status=Aprovado
    api.get(`/medicamento-aims?page=${page}&perPage=${perPage}&sortBy=nome:${order}&status=Aprovado`)
      .then((res) => {
        // console.log(res)
        setConfigLista(res?.data);
        setMedicamentos(res.data.medicamentoAIMs);
      })
      .catch(() => {
      }).finally(() => setIsLoading(false));
  }, [page, perPage, order]);

  const medicamentosFiltrados = useMemo(() =>
    medicamentos.filter(medicamento =>
      medicamento?.nome?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    ),
    [medicamentos, searchTerm]
  );


  const handleDownload = (url: string | undefined, nome: string) => {
    if (!url) {
      alert("Documento não disponível");
      return;
    }

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", nome); // força o download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  // const Estado = ({ status }: { status: string }) => {
  //   return (
  //     <>
  //       {status === 'Aprovado' ?
  //         <Typography style={{ padding: 10, background: '#7ebf42', color: '#fff',  lineHeight: 1.5, height: 40 }} align="center" variant="body1">
  //           APROVADO
  //         </Typography>
  //         :
  //         <Typography noWrap style={{ padding: 10, background: 'red', color: '#fff',  lineHeight: 1.5,height: 40  }} align="center" variant="body1">
  //           NÃO APROVADO
  //         </Typography>
  //       }
  //     </>
  //   )
  // }

  return (
    <Box sx={{ minHeight: '72vh', maxWidth: '90vw', mx: 'auto' }}>

      {/* <HeaderSession title={`LISTA DE MEDICAMENTOS REGISTADOS EM ANGOLA ATÉ ${new Date().toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' }).toUpperCase()}`} /> */}
      {/* <HeaderSession title={'LISTA NACIONAL DE MEDICAMENTOS ESSENCIAIS'} /> */}
      <HeaderSession title={'BASE DE DADOS DE MEDICAMENTOS'} />

      <Box marginBottom={2} display="flex" justifyContent="space-between">
        <TextField
          sx={{ textAlign: 'center' }}
          label="Filtrar por nome ou categoria"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          fullWidth
        />
      </Box>

      {medicamentos.length > 0 &&
        <TableContainer sx={{ border: "1px black" }} component={Paper}>
          <Table sx={{ border: "1px", borderColor: "black" }}>
            <TableHead sx={{ backgroundColor: "#dcdede" }}>
              <TableRow>
                <TableCell><Typography noWrap ><b>Nº</b></Typography></TableCell>
                {/* <TableCell><Typography noWrap><b>Estado</b></Typography></TableCell> */}
                <TableCell><Typography noWrap><b>Nome de marca</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>DCI e dosagem</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Apresentação</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Área terapêutica</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Fabricante</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Titular de AIM</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Número de registo</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Data de registo</b></Typography></TableCell>
                <TableCell><Typography noWrap><b> Nota informátiva</b></Typography></TableCell>
                <TableCell><Typography noWrap><b>Correspondente a RCM</b></Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ border: "1px", borderColor: "black" }}>
              {medicamentosFiltrados.map((medicamento, index) => (
                <TableRow
                  key={medicamento._id}
                  hover
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>
                    {index + 1}
                  </TableCell>
                  {/* <TableCell><Estado status={medicamento?.status} /></TableCell> */}
                  <TableCell>{medicamento?.nome}</TableCell>
                  <TableCell>
                    {medicamento?.dciDosagem}
                  </TableCell>
                  <TableCell>
                    {medicamento?.apresentacao}
                  </TableCell>
                  <TableCell>
                    {medicamento?.areaTerapeutica}
                  </TableCell>
                  <TableCell>
                    {medicamento?.fabricante}
                  </TableCell>
                  <TableCell>
                    {medicamento?.titularAIM}
                  </TableCell>
                  <TableCell>
                    {medicamento?.numeroRegisto}
                  </TableCell>
                  <TableCell>
                    {new Date(
                      medicamento?.dataRegisto ?? ""
                    ).toLocaleDateString()}
                  </TableCell>

                  <TableCell>
                    Baixar
                    <IconButton
                      style={{ color: '#99288b' }}
                      onClick={() => medicamento?.docs?.folhetoInformativo && handleDownload(medicamento?.docs?.folhetoInformativo, `${medicamento?.nome}-folheto-informátivo.pdf`)}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    Baixar
                    <IconButton
                      style={{ color: '#99288b' }}
                      onClick={() => medicamento?.docs?.rcm && handleDownload(medicamento?.docs?.rcm, `${medicamento?.nome}-rcm.pdf`)}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>


          <Paginacao
            configLista={configLista}
            lista={medicamentos}
            page={page}
            perPage={perPage}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </TableContainer>
      }

      {isLoading && <Loading />}

      {medicamentos.length < 1 && <ListaVazia text={''} />}
    </Box >
  );
};

export default MedicamentosRegistados;
